import type { ModelId, ModelTier } from '@/domains/pages/model-savings/types';

const TIER_TO_MODEL_ID: Record<ModelTier, ModelId> = {
  light: 'haiku',
  medium: 'sonnet',
  frontier: 'opus',
  flagship: 'flagship',
};

/** Normalizes actual_tier / optimal_tier group names from the aggregates API. */
export function normalizeTierGroupName(groupName: string | undefined): ModelTier | null {
  if (!groupName) return null;

  switch (groupName.trim().toLowerCase()) {
    case 'light':
      return 'light';
    case 'medium':
    case 'mid':
      return 'medium';
    case 'frontier':
      return 'frontier';
    case 'flagship':
      return 'flagship';
    default:
      return null;
  }
}

export function tierToModelId(tier: ModelTier): ModelId {
  return TIER_TO_MODEL_ID[tier];
}

export function tierGroupNameToModelId(groupName: string | undefined): ModelId | null {
  const tier = normalizeTierGroupName(groupName);
  return tier ? tierToModelId(tier) : null;
}
